module.exports = __webpack_public_path__ + "static/media/betSettings.1663b215.svg";